'use client';
import styles from './ticketMessageDetail.module.scss';
import { Empty, Result, Spin } from 'antd';
import React, { useContext, useEffect, useState } from 'react';
import { PaginationType, TicketMessageType, TicketType } from 'types';
import MessageCardComp from './messageCard/messageCard.index';
import { GlobalContext } from 'context';
import { RestAPI } from 'scripts';
import { API } from 'data';
import CustomInputComp from '../customInput/customInput.index';

function TicketMessageDetailComp({ data, onSent }: { data?: TicketType; onSent: (e: TicketMessageType) => void }) {
    const { profile } = useContext(GlobalContext);
    const [messages, setMessages] = useState<TicketMessageType[]>();
    const [error, setError] = useState<string>();

    useEffect(() => {
        if (data?.id) {
            RestAPI.get<PaginationType<TicketMessageType>>(API.ticket.messages, {
                ticket: data.id,
                page: 1,
                page_size: 300,
            })
                .then((res) => {
                    setMessages(res.data.data);
                    RestAPI.post(API.chat.seen(data.id), {});
                })
                .catch(() => setError('خطایی رخ داده است. لطفا مجددا تلاش نمایید'));
        }
    }, [data?.id]);

    const formatter = (date: string) => {
        const targetDate = new Date(date);
        const formattedDate = targetDate.toLocaleDateString('fa-IR', {
            year: 'numeric',
            month: 'long',
            day: 'numeric',
        });
        return formattedDate;
    };

    if (error?.length) return <Result status="error" title="خطا در بارگذاری" subTitle={error} />;
    if (!messages)
        return (
            <div className={`w-100 pv-9 center-content flex-1`}>
                <Spin />
            </div>
        );

    const chatItems: { date: string; messages: TicketMessageType[] }[] = [];

    messages
        ?.sort((a, b) => b.id - a.id)
        .forEach((item) => {
            const lastOne = chatItems[chatItems.length - 1];
            if (!lastOne || new Date(item.created_at).toDateString() !== new Date(lastOne.date).toDateString()) {
                chatItems.push({ date: item.created_at, messages: [item] });
            } else {
                lastOne.messages.push(item);
                chatItems[chatItems.length - 1] = lastOne;
            }
        });

    return (
        <div className={styles['chat']}>
            <div className={`${styles['header-detail-chat']} center-content-y`}>
                {/* <IoIosArrowForward
                    className="d-md-none-i pointer ml-2-i"
                    onClick={() => onBack()}
                    size={20}
                    color={theme === ThemeEnum.light ? COLORS.black1 : COLORS.gray2}
                /> */}
                <div className={`${styles['title-chat']} center-content-y flex-between p-1 w-100`}>
                    <p className="t-p1 t-400 t-l-black1">{data?.title}</p>
                    {/* <BiDotsVerticalRounded
                        size={20}
                        color={theme === ThemeEnum.light ? COLORS.black1 : COLORS.gray2}
                        className="pointer"
                    /> */}
                </div>
            </div>
            <div
                style={{ padding: '140px 24px 86px 24px', width: '100%', height: '100%', overflowY: 'auto' }}
                className={styles['messages-box']}
            >
                {chatItems.length ? (
                    <>
                        {chatItems.map((msg, dateIndex) => (
                            <React.Fragment key={dateIndex}>
                                <div className={`${styles['messages-box']} d-flex flex-column`}>
                                    {msg.messages.map((txt) => (
                                        <MessageCardComp
                                            key={txt.id}
                                            className={
                                                profile?.id === txt.user.id
                                                    ? styles['me-message']
                                                    : styles['audience-message']
                                            }
                                            data={txt}
                                        />
                                    ))}
                                </div>
                                <p className="t-400 t-p3 t-l-gray1 mv-2 text-center">{formatter(msg.date)}</p>
                            </React.Fragment>
                        ))}
                    </>
                ) : (
                    <Empty
                        className="w-100 center-content-i mt-3-i m-0-i"
                        description={
                            <p className="t-p2 t-l-gray1 t-400 text-center">
                                شما تا اکنون پیامی ارسال نکرده اید. برای ارسال پیام شروع به تایپ کردن کنید.
                            </p>
                        }
                    />
                )}
            </div>
            <div className={styles['input']}>
                <CustomInputComp
                    ticket={data}
                    onSubmit={(e) => {
                        setMessages([...messages, e]);
                        onSent(e);
                    }}
                />
            </div>
        </div>
    );
}

export default TicketMessageDetailComp;
